import { localisedValue } from "utils"
const getClientProfileInitialValues = client => {

  if (client) {
    return {
      // Personal Information
      relationshipStrength: client?.relationshipStrength?.toString() || null,
      gender: client?.gender?.toString() || null,
      nationalityId: client?.nationalityId || null,
      maritalStatus: client?.maritalStatus?.toString() || null,
      children: client?.children == 1 ? "true" : client?.children == 0 ? "false" : null,
      taxResidency: client?.taxResidency?.toString() || null,

      // Financial & Professional Details
      companyNameProfiling: client?.companyNameProfiling || "",
      industryId: client?.industryId || null,
      occupation: client?.occupation || null,
      occupationOtherText: client?.occupation =="others" ? client?.occupationOtherText : null,

      teamSize: client?.teamSize?.toString?.() || client?.teamSize || null,
      netWorth: [+client?.netWorth?.from || 0, +client?.netWorth?.to || 0],

      annualRevenueAUM: [+client?.annualRevenueAUM?.from || 0, +client?.annualRevenueAUM?.to || 0],

      clientRatingId: client?.clientRatingId || null,
      keyShareholderUBO: client?.keyShareholderUBO || "",

      // Purchase Criteria
      budget: [0, client?.budget || 0],
      interestedTypeId: client?.interestedTypeId || null,
      area: client?.area?.toString() || null,
      preferredCityIds: client?.preferredCityIds?.map(id => id?.toString()) || null,
      preferredCityRegion: client?.preferredCityIds?.length==1? client?.preferredCityRegion : null,
      preferredLocalityId: client?.preferredCityIds?.length==1? client?.preferredLocalityId?.toString() : null,
      hasExistingProperty: client?.hasExistingProperty == 1 ? "yes" : client?.hasExistingProperty == 0 ? "no" : null,
      intent: client?.intent || null,
      buyingIntentId: client?.buyingIntentId || null,
      preferredFinancing: client?.preferredFinancing?.toString() || null,

      // Market Exposure
      politicalExposure: client?.politicalExposure?.toString() || null,
      realEstateIndustryExposure: client?.realEstateIndustryExposure?.toString() || null,
      marketExposure: client?.marketExposure?.toString() || null,
      socialCapital: client?.socialCapital?.toString?.() || client?.socialCapital || null,

      // Investment Strategy
      investmentStrategy: client?.investmentStrategy || null,
      investmentPeriod: client?.investmentPeriod?.toString() || null,
      targetAnnualIncomePercent: client?.targetAnnualIncomePercent || null,
      targetCapitalReturnPercent: client?.targetCapitalReturnPercent || null,
      targetAllocation: [+client?.targetAllocation?.from || 0, +client?.targetAllocation?.to || 0],
      capitalStructure: client?.capitalStructure?.toString() || null,
      leverageRatio: [+client?.leverageRatio?.from || 0, +client?.leverageRatio?.to || 0],
      assetClass: client?.assetClass || null,
      riskProfile: client?.riskProfile || null,
      currentInvestmentPortfolio: Array.isArray(client?.currentInvestmentPortfolio)
        ? client?.currentInvestmentPortfolio
        : client?.currentInvestmentPortfolio
          ? [client?.currentInvestmentPortfolio]
          : null,

      // Services Required
      residencyRequirement: client?.residencyRequirement?.toString() || null,
      propertyManagement: client?.propertyManagement?.toString() || null,
      legalTaxServices: client?.legalTaxServices || null,
      travelLogisticsServices: client?.travelLogisticsServices || null,
      shortTermLease: client?.shortTermLease?.toString() || null,
      longTermLease: client?.longTermLease?.toString() || null,
      resaleFlipping: client?.resaleFlipping?.toString() || null,
      preferredCountryId: client?.preferredCountryId?.toString() || null,
    }
  }
}

export default getClientProfileInitialValues
